var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartbeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.94477C0 1.76613 1.76613 0 3.94477 0H10.8052C12.9839 0 14.75 1.76613 14.75 3.94477V10.8052C14.75 12.9839 12.9839 14.75 10.8052 14.75H3.94477C1.76613 14.75 0 12.9839 0 10.8052V3.94477ZM5.37887 10.5352C5.52305 10.7515 5.76894 10.8777 6.02872 10.8687C6.2885 10.8598 6.52513 10.717 6.65409 10.4913L8.70299 6.90571L9.44837 8.39646C9.57541 8.65055 9.83511 8.81105 10.1192 8.81105H11.4913C11.9055 8.81105 12.2413 8.47526 12.2413 8.06105C12.2413 7.64683 11.9055 7.31105 11.4913 7.31105H10.5827L9.41791 4.98145C9.29422 4.73406 9.04439 4.57482 8.7679 4.56715C8.49141 4.55947 8.23314 4.7046 8.09591 4.94476L5.9538 8.69345L5.25485 7.64502C5.11575 7.43637 4.88158 7.31105 4.63081 7.31105H3.25872C2.84451 7.31105 2.50872 7.64683 2.50872 8.06105C2.50872 8.47526 2.84451 8.81105 3.25872 8.81105H4.22943L5.37887 10.5352Z",
    fill: "#CAE9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbeat);
export default __webpack_public_path__ + "static/media/Heartbeat.8a81d841c96db1cb090fc627ed79e48e.svg";
export { ForwardRef as ReactComponent };